module.exports = __webpack_public_path__ + "static/media/logo.42693576.png";